<template>
  <el-form ref="addFrom" :model="addFrom" :rules="rules" label-width="110px">
    <el-row>
      <el-col :span="24">
        <el-form-item label="课题属性" prop="ktsx">
          <el-select
            v-model="addFrom.ktsx_n"
            filterable
            disabled
            default-first-option
            style="width: 100%"
            placeholder="请选择课题属性"
            @change="handleChangeKt"
          >
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item label="所属阶段" prop="ssjd">
          <el-select
            v-model="addFrom.ssjd_n"
            filterable
            disabled
            default-first-option
            style="width: 100%"
            placeholder="请选择所属阶段"
          >
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item label="课题负责人">
          <el-input disabled v-model="addFrom.fzr"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item label="课题安排" v-if="addFrom.ssjd == '3'">
          <el-radio-group disabled v-model="addFrom.ktap">
            <el-radio label="1">一审安排</el-radio>
            <el-radio label="2">二审安排</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-col>

      <el-col :span="24">
        <el-form-item label="评审评委" prop="pws">
          <el-select
            v-model="addFrom.pws"
            default-first-option
            filterable
            :multiple="true"
            style="width: 100%"
            placeholder="请选择评委"
          >
            <el-option
              v-for="item in pswyOptions"
              :label="item.name"
              :value="item.value"
              :key="item.value"
            />
          </el-select>
        </el-form-item>
      </el-col>

      <el-col :span="24">
        <el-form-item label="开始时间" prop="qsrq" key="10">
          <el-date-picker
            type="datetime"
            placeholder="选择日期"
            v-model="addFrom.qsrq"
            :clearable="false"
          >
          </el-date-picker>
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-row>
          <el-col :span="24">
            <el-form-item label="结束时间" prop="jsrq" key="10">
              <el-date-picker
                type="datetime"
                placeholder="选择日期"
                v-model="addFrom.jsrq"
                :clearable="false"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="24">
        <el-form-item label="会议纪要员" prop="hyjyy">
          <treeselect
            v-model="addFrom.hyjyy"
            placeholder="请选择"
            :options="deptUser"
            :disable-branch-nodes="true"
            :show-count="true"
            value-consists-of="LEAF_PRIORITY"
            no-results-text="未搜到任何结果"
            :clear-on-select="true"
            :normalizer="normalizer"
            style="width: 100%; line-height: 18px; margin-top: 4px"
            :limit="1"
            :max-height="200"
          />
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item label="评审方式" prop="psfs">
          <el-select
            v-model="addFrom.psfs"
            filterable
            default-first-option
            style="width: 100%"
            placeholder="请选择评审方式"
          >
            <el-option label="线上" value="1"></el-option>
            <el-option label="线下" value="2"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item label="关键物">
          <el-input
            v-model="addFrom.words"
            maxlength="50"
            show-word-limit
          ></el-input>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>
<script>
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { mapGetters } from "vuex";
import { getDictData } from "@/api/task.js";
import { formatMomentDate, sizeFormat, checkVal } from "@/utils/utils";
import moment from "moment";
import {
  getCourseQueryCondition,
  assignList,
  getStepArrangeById,
  stepArrangeSave,
} from "@/api/course.js";
export default {
  name: "arrangeEdit",
  computed: {
    ...mapGetters(["deptUser"]),
  },
  components: { Treeselect },
  props: ["mxParams"],
  data() {
    return {
      normalizer(node) {
        return {
          children: node.users,
        };
      },
      rules: {
        pws: [{ required: true, message: "课题评委不能为空", trigger: "blur" }],
        qsrq: [
          { required: true, message: "开始时间不能为空", trigger: "change" },
        ],
        jsrq: [
          { required: true, message: "结束时间不能为空", trigger: "change" },
        ],
        hyjyy: [
          { required: true, message: "会议纪要员不能为空", trigger: "change" },
        ],
        psfs: [
          { required: true, message: "评审方式不能为空", trigger: "change" },
        ],
      },
      addFrom: {
        type: "1",
        id: this.mxParams.id,
        ktsx_n: this.mxParams.ktsx,
        ssjd_n: this.mxParams.ssjd,
        ktsx: null,
        ssjd: null,
        fzr: this.mxParams.fzr,
        ktap: null,
        cids: null,
        pws: null,
        qsrq: null,
        jsrq: null,
        hyjyy: null,
        psfs: null,
        words: null,
      },
      ktsxOptions: [],
      ssjdOptions: [],
      pswyOptions: [],
      ktsOptions: [],

      parentDialog: false,
    };
  },

  created() {
    if (!this.deptUser || this.deptUser.length == 0) {
      this.$store.dispatch("common/getDeptUser");
    }
    this.initData();
  },
  methods: {
    getPswyOptions() {
      //评委委员
      const params = { type: 6, ktsx: this.addFrom.ktsx };
      getCourseQueryCondition(params).then((res) => {
        if (res.code === 0) {
          this.pswyOptions = res.data;
        }
      });
    },
    initData() {
      //获取要编辑数据
      let id = this.mxParams.id;
      const params1 = { id };
      getStepArrangeById(params1).then((res) => {
        if (res.code === 0) {
          this.addForm = res.data[0];
          this.addFrom.ktsx = this.addForm.ktsx;
          this.addFrom.ssjd = this.addForm.ssjd;
          this.addFrom.cids = this.addForm.cid;
          this.addFrom.qsrq = this.addForm.qsrq;
          this.addFrom.jsrq = this.addForm.jsrq;
          this.addFrom.pws = this.addForm.pws.split(",").map(Number);
          this.addFrom.hyjyy = this.addForm.hyjyy;
          this.addFrom.psfs = this.addForm.psfs;
          this.addFrom.words = this.addForm.words;
          this.addFrom.ktap = this.addForm.ktap;
          this.getPswyOptions();
        }
      });
    },
    handleAdd() {
      this.$refs["addFrom"].validate((valid) => {
        if (valid) {
          let qsrq = moment(this.addFrom.qsrq).format("YYYY-MM-DD HH:mm:ss");
          let jsrq = moment(this.addFrom.jsrq).format("YYYY-MM-DD HH:mm:ss");
          if (qsrq > jsrq) {
            this.$message.error("开始时间不能大于结束时间！");
            return false;
          }
          let pws = this.addFrom.pws.join(",");
          const params = { ...this.addFrom, qsrq, jsrq, pws };
          stepArrangeSave(params).then((res) => {
            if (res.code == 0) {
              this.$message.success(res.msg);
              this.$emit("giveFather", this.parentDialog);
            } else {
              this.$message.error(res.msg);
            }
          });
        }
      });
    },
    giveFather() {
      this.parentDialog = false;
    },
  },
};
</script>
<style lang="less" scoped>
</style>